import { useEffect, useCallback } from 'react'

// Current version from build time
const CURRENT_VERSION = process.env.REACT_APP_VERSION || '0.0.0'

// Check interval: 5 minutes
const CHECK_INTERVAL = 5 * 60 * 1000

export const useVersionCheck = () => {
  const checkVersion = useCallback(async () => {
    try {
      // Add cache-busting timestamp to avoid cached version.json
      const response = await fetch(`/version.json?t=${Date.now()}`)
      if (!response.ok) {
        console.warn('Version check failed: unable to fetch version.json')
        return
      }

      const data = await response.json()
      const serverVersion = data.version

      if (serverVersion && serverVersion !== CURRENT_VERSION) {
        console.log(
          `New version available: ${serverVersion} (current: ${CURRENT_VERSION})`
        )

        // Navigate with version query to bust cache
        const currentUrl = new URL(window.location.href)
        const currentVersionParam = currentUrl.searchParams.get('v')

        // Only redirect if we haven't already redirected to this version
        if (currentVersionParam !== serverVersion) {
          currentUrl.searchParams.set('v', serverVersion)
          window.location.href = currentUrl.toString()
        }
      }
    } catch (error) {
      console.warn('Version check error:', error)
    }
  }, [])

  useEffect(() => {
    // Initial check after 30 seconds (give the app time to load)
    const initialTimeout = setTimeout(checkVersion, 30 * 1000)

    // Then check every 5 minutes
    const interval = setInterval(checkVersion, CHECK_INTERVAL)

    return () => {
      clearTimeout(initialTimeout)
      clearInterval(interval)
    }
  }, [checkVersion])

  return {
    currentVersion: CURRENT_VERSION,
    checkNow: checkVersion,
  }
}
